import * as React from 'react'
import styled from 'styled-components'

import { styles as S } from '@bob/design-system'
import * as ds from '@bob/design-system'

export type VideoProps = {
    __typename: 'Video'
    sys: { id: string }
    preview: {
        url: string
        width: number | null
        height: number | null
        title: string | null
        description: string | null
    }
    url: string
}

export function Video(video: VideoProps) {
    return (
        <MediaLoader
            url={video.url}
            placeholder={
                <S.wysiwyg.Figure>
                    <S.wysiwyg.OverflowContainer>
                        <S.wysiwyg.Image
                            src={video.preview.url}
                            alt={video.preview.title ?? undefined}
                        />
                    </S.wysiwyg.OverflowContainer>
                    {video.preview.description && (
                        <S.wysiwyg.Caption
                            dangerouslySetInnerHTML={{
                                __html: video.preview.description
                            }}
                        />
                    )}
                </S.wysiwyg.Figure>
            }
        />
    )
}

const MediaLoader = styled(ds.MediaLoader)`
    width: 100%;

    ${S.wysiwyg.Image} {
        transition: transform 0.3s ease-in-out;
    }

    @media screen and (${ds.breakpoint.LAPTOP}) {
        &:hover {
            ${S.wysiwyg.Image} {
                transform: scale(1.1);
            }
        }
    }
`
